import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ChangeDetectorRef } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { GoogleService } from '../../../../shared/Google.service';
import { Book } from '../../../../shared/models/book';
import { EBEpouchdbService } from '../../../../EBE/EBEpouchdb.service';
import { EditorService } from '../../editor.service';
import { IS_ElectronService } from '../../../../shared/IS_Electron.service';
@Component({
  selector: 'app-mediacommon',
  templateUrl: './mediacommon.component.html',
  styleUrls: ['./mediacommon.component.css']
})
export class MediacommonComponent implements OnInit {
  @Input() bookObj;
  @Input() updateData: any;
  @Output() onSelectGimage = new EventEmitter<string>();
  @Output() hideWidthheight = new EventEmitter<string>();
  googleImageData;
  imageDetails;
  imageUrl;
  driveFolderData;
  driveAllCloudData;
  loadNext = 1;
  selectedGalleryImage = false;
  selectedCloudImage = false;
  selectedWebImage = false;
  galleryimageUrl;
  webImageUrl;
  cloudImageUrl;
  showBackHeader = false;
  showUploadButton = false;
  constructor(private http: HttpClient, private GoogleService: GoogleService, private pouchService: EBEpouchdbService, private ele: ElementRef, private cdr: ChangeDetectorRef, private editorService: EditorService, private ElectronService: IS_ElectronService) { }

  ngOnInit() {
    if (this.updateData) {
      this.intializeData(this.updateData);
    }
  }

  intializeData(data) {
    if (data.url == "data/assets/media/Bg-image.svg") {
      this.galleryimageUrl = false;
    } else {
      this.galleryimageUrl = data.url;
    }



  }

  readImageUrl(fileInput) {
    this.imageDetails = fileInput;
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'block';
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();
      reader.onload = ((e) => {
        this.imageUrl = e.target['result'];
        this.applyImage();
      });

      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }
  applyImage() {
    // if (this.bookObj.gDriveID == "" || this.bookObj.gDriveID == undefined) {
    //   this.GoogleService.Createfolder(this.bookObj._id, this);
    // }
    // else {
    if (this.ElectronService.IS_ELECTRON) {
      this.ElectronService.insertFileintoMediaFolder(this.imageDetails.target.files[0], this);
    }
    else {
      if (localStorage.currentDriveMediaId)
        this.GoogleService.insertFileintofloder(this.imageDetails.target.files[0], this.imageDetails.target.files, localStorage.currentDriveMediaId, false, this);

    }

    //}
  }

  // updateCreateFolderID(id) {
  //   this.bookObj.gDriveID = id;
  //   this.pouchService.updateBookObj(this.bookObj);
  //   this.GoogleService.insertFileintofloder(this.imageDetails.target.files[0], this.imageDetails.target.files, id, false, this);
  // }
  imageAddedIntoDrive(file) {

    if (this.ElectronService.IS_ELECTRON) {
      this.imageUrl = file;
    }
    else {
     // this.imageUrl = file.thumbnailLink;
     this.imageUrl = "https://lh3.google.com/u/0/d/" + file.id;
    }

    if (this.imageUrl) {

      // this.galleryimageUrl = this.imageUrl;
      this.showUploadButton = false;
      this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
    
      let imgObj: any = {
        'type': 'MyGallery',
        'url': this.imageUrl
      }
      this.onSelectGimage.emit(imgObj);
    }
  }

  searchMediaImgOnEnter(event, keyword, status) {
    if (event.keyCode == 13) {
      this.searchMediaImages(keyword, status)
    }
  }


  ApplyDriveImages(id) {
    let img = "https://lh3.google.com/u/0/d/" + id;
    this.cloudImageUrl = img;
    this.selectedCloudImage = !this.selectedCloudImage;
    let imgObj: any = {
      'type': 'Cloud',
      'url': img
    }
    this.onSelectGimage.emit(imgObj);
    this.galleryimageUrl = "";
    this.webImageUrl = "";
    this.imageUrl = "";
    this.showBackHeader = false;

  }
  retrieveGdata() {
    this.hideWidthheight.emit('false');
    this.selectedCloudImage = !this.selectedCloudImage;
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'block';
    this.GoogleService.GetGoogleDriveCloudData(this, 'image');
    this.showBackHeader = true;
  }
  getAllImageData(data) {
    this.driveAllCloudData = data;
    this.cdr.detectChanges();
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
  }



  // getAllFolderData(data) {
  //   this.driveAllCloudData = data;
  //   this.cdr.detectChanges();
  //   this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
  // }

  retrieveFolderData() {

    this.hideWidthheight.emit('false');
    this.selectedGalleryImage = !this.selectedGalleryImage;
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'block';
    if (this.ElectronService.IS_ELECTRON) {
      this.ElectronService.retrieveAllFilesInFolder(this, 'image');
    }
    else {
      this.GoogleService.retrieveAllFilesInFolder('', this, 'image');
    }

    this.showBackHeader = true;
  }

  getAllCloudFloderData(data) {
    this.driveFolderData = data;
    this.cdr.detectChanges();
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
  }

  ApplyFolderDriveImages(id) {
    let img;
    if (this.ElectronService.IS_ELECTRON)
      img = id;
    else
      img = "https://lh3.google.com/u/0/d/" + id;
    this.galleryimageUrl = img;
    this.selectedGalleryImage = !this.selectedGalleryImage;
    let imgObj: any = {
      'type': 'MyGallery',
      'url': img
    }
    this.onSelectGimage.emit(imgObj);
    this.webImageUrl = "";
    this.cloudImageUrl = "";
    this.imageUrl = "";
    this.showBackHeader = false;
  }

  retrieveWebData() {
    this.hideWidthheight.emit('false');
    this.selectedWebImage = !this.selectedWebImage;
    this.showBackHeader = true;
  }


  searchMediaImages(keyword, status) {
    this.ele.nativeElement.querySelector('.lds-roller').style.display = 'block';
    if (status == 'prev') {
      this.loadNext--;
      if (this.loadNext < 1) {
        this.loadNext = 1;
      }
    } else if (status == 'next') {
      this.loadNext++;
    } else if (status == 'search') {
      this.googleImageData = [];
      this.loadNext = 1;
    }
    this.http.get("https://www.googleapis.com/customsearch/v1?cx=001290887029579293036:sq1dagagltc&imgSize=large&q=" + keyword + "&searchType=image&start=" + this.loadNext + "&key=AIzaSyAsVZZNEFil3tjrDRAntIvR_1kWTHxTUWo")
      .subscribe(data => {
        this.googleImageData = data;
        this.googleImageData = this.googleImageData.items;
        this.ele.nativeElement.querySelector('.lds-roller').style.display = 'none';
      })

  }
  selectWebImage(webUrl) {
    this.webImageUrl = webUrl;
    this.selectedWebImage = !this.selectedWebImage;
    let imgObj: any = {
      'type': 'Web',
      'url': webUrl
    }
    this.onSelectGimage.emit(imgObj);
    this.galleryimageUrl = "";
    this.cloudImageUrl = "";
    this.imageUrl = "";
    this.showBackHeader = false;

  }
  switchToimageGallery() {
    this.selectedCloudImage = false;
    this.selectedWebImage = false;
  }
  switchToimageCloud() {
    this.selectedGalleryImage = false;
    this.selectedWebImage = false;
  }
  switchToimageWeb() {
    this.selectedGalleryImage = false;
    this.selectedCloudImage = false;
  }
  backToinitialState() {
    this.showBackHeader = !this.showBackHeader;
    this.selectedGalleryImage = false;
    this.selectedWebImage = false;
    this.selectedCloudImage = false;
    this.hideWidthheight.emit('true');
  }
  switchToSelectOpt() {
    this.hideWidthheight.emit('true');
  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/mediacommon/mediacommon.component.ts